// extracted by mini-css-extract-plugin
export default {"switch":"Switch_switch__n09o8","switch__container":"Switch_switch__container__6sR4p","switch__input":"Switch_switch__input__RaGYO","switch__slide":"Switch_switch__slide__KB33c"};